import React, {
	useState,
	useEffect,
	useCallback,
	useRef,
	useContext
} from "react";
import Flatpicker from "react-flatpickr";
import Fade from "react-fade-in";
import PlaceHolder from "../DATA/Loader";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import envContext from "../context/EnvContext";

const Times = (props) => {
	const [from, setFrom] = useState("loading");
	const [to, setTo] = useState("loading");
	const [pickFrom, setPickFrom] = useState("loading");
	const [pickTo, setPickTo] = useState("loading");
	const [DropFrom, setDropFrom] = useState("loading");
	const [DropTo, setDropTo] = useState("loading");
	const [error, setError] = useState("none");

	const validator = useRef(
		new SimpleReactValidator({
			autoForceUpdate: this,
			className: "text-danger"
		})
	);

	const env = useContext(envContext);

	//production env assignments
	// const { host } = env.pro;
	// let url = `${host}/home/get_item_settings_react/${props.item.id}/TIMES`;

	//<<< Dev env assignment >>>
	const { proto } = env.dev;
	let url = `${proto}//mcclearyrentals.com/home/get_item_settings_react/${props.item.id}/TIMES`;

	const getAvailableTimes = useCallback(async () => {
		const time = await fetch(url);
		const jsonData = await time.json();
		if (typeof jsonData === "object") {
			setDropFrom(jsonData[0].pickup_time_from);
			setDropTo(jsonData[0].pickup_time_to);
			setPickFrom(jsonData[0].drop_time_from);
			setPickTo(jsonData[0].drop_time_to);
		} else {
			setError("block");
		}
	}, [url]);

	useEffect(() => {
		getAvailableTimes();
	}, [getAvailableTimes]);

	const handleClick = (e, from) => {
		switch (from) {
			case "from":
				setFrom(moment(e[0]));
				break;
			case "to":
				setTo(moment(e[0]));
				break;
			default:
				break;
		}
	};

	if (
		pickFrom !== "loading" &&
		pickTo !== "loading" &&
		DropFrom !== "loading" &&
		DropTo !== "loading"
	) {
		return (
			<>
				<Fade>
					<div
						className="col-lg-6"
						style={{
							display: "inline",
							float: "left",
							marginTop: "5px",
							marginBottom: "5px"
						}}
					>
						<Flatpicker
							options={{
								enableTime: true,
								noCalendar: true,
								dateFormat: "H:i K",
								minTime: pickFrom,
								maxTime: pickTo
							}}
							placeholder="Start"
							onChange={(e) => handleClick(e, "from")}
							onBlur={(e) => handleClick(e, "from")}
							onClick={(e) => handleClick(e, "from")}
							onOpen={(e) => handleClick(e, "from")}
							onClose={(e) => handleClick(e, "from")}
						/>
						<input
							type="hidden"
							id="pick"
							name="pick"
							value={from === "loading" ? "" : from.format("LT")}
							onChange={validator.current.showMessageFor("pick")}
							onKeyDown={validator.current.showMessageFor("pick")}
							onInputCapture={validator.current.showMessageFor("pick")}
						/>
						{from !== "loading"
							? validator.current.message(
									"pick",
									from.isValid(),
									"required|boolean"
							  )
							: ""}
					</div>
					<div
						className="col-lg-6"
						style={{
							display: "inline",
							float: "right",
							marginTop: "5px",
							marginBottom: "5px"
						}}
					>
						<Flatpicker
							options={{
								enableTime: true,
								noCalendar: true,
								dateFormat: "H:i K",
								minTime: DropFrom,
								maxTime: DropTo
							}}
							placeholder="End"
							onChange={(e) => handleClick(e, "to")}
							onBlur={(e) => handleClick(e, "to")}
							onClick={(e) => handleClick(e, "to")}
							onOpen={(e) => handleClick(e, "to")}
							onClose={(e) => handleClick(e, "to")}
						/>

						<input
							type="hidden"
							name="drop"
							value={to === "loading" ? "" : to.format("LT")}
							onChange={(e) => {
								validator.current.showMessageFor("drop");
								console.log(e);
							}}
							onKeyDown={validator.current.showMessageFor("drop")}
						/>
						{to !== "loading"
							? validator.current.message(
									"drop",
									to.isValid(),
									"required|boolean"
							  )
							: ""}
					</div>
				</Fade>
			</>
		);
	} else if (
		pickFrom === "loading" &&
		pickTo === "loading" &&
		DropFrom === "loading" &&
		DropTo === "loading"
	) {
		return <PlaceHolder />;
	} else {
		if (error !== "block") {
			return <div>loading</div>;
		} else {
			return <div>unable to load times</div>;
		}
	}
};

export default Times;
